module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/F0018572_logo.985013eb.png";